const sidebarConstants = {
  HIDE_SIDEBAR:         'HIDE_SIDEBAR',
  SHOW_SIDEBAR:         'SHOW_SIDEBAR',
  SHOW_GRATITUDE_MODAL: 'SHOW_GRATITUDE_MODAL',
  HIDE_GRATITUDE_MODAL: 'HIDE_GRATITUDE_MODAL',

  CALL_ME_SIDEBAR: 'CALL_ME_SIDEBAR',
  PROFILE_SIDEBAR: 'PROFILE_SIDEBAR',
  WATCHED_SIDEBAR: 'WATCHED_SIDEBAR',
};

export default sidebarConstants;